import {InvoiceDao} from '../../dao';
import {ErrorModel, InvoiceModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'CANCEL_INVOICE';

export async function cancelInvoice(userData: Record<string, any>, invoicePayload: any, id: number) {
    try {
        const invoice = await InvoiceDao.cancelInvoice(userData.userToken, invoicePayload, id);

        const invoiceParsed = InvoiceModel.parseInvoice(invoice);

        return invoiceParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
